import { parseTenantSlug } from "@/lib/ui/platform";

export {
  platformPackageContentHref,
  platformPackageDocumentFileHref,
  platformPackageDocumentHref,
  platformPackageHref,
  platformPackageJournalHref,
  platformPackageReleasesHref,
  platformPackageTenantsHref,
  platformPackageWikiHref,
  platformPackageWikiClaimEditsHref,
  platformPackagesHref,
  platformTenantPackagesHref,
} from "@/lib/ui/platform";

export type KnowledgePackageStatus = "DRAFT" | "PUBLISHED" | "ARCHIVED";

export const knowledgePackageCopy = {
  nav: "Пакеты знаний",
  title: "Пакеты знаний",
  description:
    "Каталог Knowledge Pack. Сбор и релизы — в Publisher; здесь регистрация пакета, назначение релиза тенанту и индекс.",
  create: "Создать пакет",
  createTitle: "Новый пакет знаний",
  pendingSave: "Сохраняем…",
  errorTitle: "Пакет знаний",
  savedTitle: "Пакет",
  saved: "Сохранить",
  savedOk: "Сохранено",
  nameLabel: "Название",
  slugLabel: "Идентификатор",
  slugHelp: "Латиница, цифры и дефис. После создания не меняется.",
  slugReadonlyHelp: "Идентификатор задаётся при создании и больше не меняется.",
  domainNameLabel: "Предметная область",
  domainSlugLabel: "Идентификатор области",
  domainSlugHelp: "Например business или medicine. Можно переиспользовать.",
  domainReadonlyHelp: "Область задаётся при создании.",
  descriptionLabel: "Описание",
  descriptionHelp: "Кратко для списка и для админов организаций.",
  statusLabel: "Статус",
  statusDraft: "Черновик",
  statusPublished: "Опубликован",
  statusArchived: "Архив",
  statusHelp:
    "Черновик — только платформа. Опубликован — можно подключать организациям. Архив — отключает все подключения.",
  overviewTab: "Обзор",
  overviewHelp:
    "Карточка пакета: название, описание и статус публикации.",
  contentTab: "Контент",
  contentHelp:
    "Документы после импорта Knowledge Pack из Publisher. Здесь — просмотр, разбор текста и индекс. Сбор и редакция корпуса — только в Publisher.",
  journalTab: "Журнал",
  journalHelp:
    "Журнал разбора и индекса документов пакета. Сбор с внешних сайтов — в Publisher.",
  journalEmptyTitle: "Пока нет событий",
  journalEmptyDescription:
    "События появятся после импорта pack или индексации документов.",
  journalCheckAll: "Проверить все",
  journalCheckQueued: "Проверка в очереди.",
  journalFetchQueued: "Загрузка в очереди.",
  journalColumnWhen: "Когда",
  journalColumnKind: "Что",
  journalColumnTarget: "Где",
  journalColumnFound: "Найдено",
  journalColumnChanged: "Изменено",
  journalColumnFailed: "Ошибки",
  journalColumnDetails: "Детали",
  journalColumnError: "Ошибка",
  journalKindCheck: "Проверка",
  journalKindFetch: "Загрузка",
  journalKindParseText: "Разбор текста",
  journalKindIndex: "Индекс",
  sourceCheckNone: "Нет включённых источников с парсером",
  sourceRunMissing: "Проверка не найдена",
  sourceRunCancel: "Остановить",
  sourceRunCancelled: "Остановлено",
  sourceRunCannotCancel:
    "Остановить можно только очередь, не идущую проверку.",
  wikiTab: "Wiki",
  wikiHelp:
    "Факты, извлечённые из документов пакета. Подтвердите или отклоните — в чат организаций попадают только подтверждённые и спорные.",
  wikiEmptyTitle: "Очередь пуста",
  wikiEmptyDescription:
    "Нет фактов на проверке. После индексации документы пакета появятся здесь как PROPOSED.",
  wikiReviewDenied: "Нужна сессия платформы",
  wikiReviewMissing: "Факт не найден в этом пакете",
  wikiReviewNotQueued: "Этот факт уже не в очереди",
  releasesTab: "Релизы",
  tenantsTab: "Организации",
  tenantsHelp:
    "Каким организациям пакет доступен в поиске и чате. Отключение сразу убирает пакет из ответов.",
  tenantsEmptyTitle: "Никто не подключил",
  tenantsEmptyDescription:
    "Подключение делается в карточке тенанта или в админке организации.",
  tenantsColumnTenant: "Организация",
  tenantsColumnEnabled: "Доступ",
  releaseSection: "Релизы",
  releaseHelp:
    "Версия и changelog для организаций. Публиковать можно только при статусе «Опубликован».",
  releaseCreate: "Опубликовать релиз",
  releaseCreateTitle: "Новый релиз пакета",
  releaseVersionLabel: "Версия",
  releaseVersionHelp: "Например 1.0.0 или 2026.09.12",
  releaseNotesLabel: "Что изменилось",
  releaseNotesHelp: "Кратко: добавлено / изменено / утратило силу.",
  releaseEmptyTitle: "Пока нет релизов",
  releaseEmptyDescription:
    "Опубликуйте первый релиз — организации увидят дату и changelog.",
  releaseColumnVersion: "Версия",
  releaseColumnNotes: "Изменения",
  releaseColumnPublished: "Опубликован",
  releaseInvalidVersion: "Укажите версию релиза",
  releaseInvalidNotes: "Опишите изменения в релизе",
  releaseVersionTaken: "Такая версия уже есть у пакета",
  releaseRequiresPublished: "Сначала опубликуйте пакет (вкладка «Обзор»)",
  columnName: "Название",
  columnSlug: "Идентификатор",
  columnDomain: "Область",
  columnStatus: "Статус",
  columnCreated: "Создан",
  open: "Открыть",
  searchLabel: "Найти пакет",
  searchPlaceholder: "Название или идентификатор",
  emptyTitle: "Пока нет пакетов",
  emptyDescription: "Создайте первый пакет — потом наполните и подключите организациям.",
  emptyFilterTitle: "Ничего не найдено",
  emptyFilterDescription: "Измените запрос.",
  invalidName: "Укажите название пакета",
  invalidSlug: "Идентификатор: латиница, цифры и дефис",
  invalidDomainName: "Укажите предметную область",
  invalidDomainSlug: "Идентификатор области: латиница, цифры и дефис",
  invalidStatus: "Выберите статус",
  slugTaken: "Пакет с таким идентификатором уже есть",
  domainSlugTaken:
    "Область с таким идентификатором уже есть под другим названием",
  missingPackage: "Пакет не найден",
  missingTenant: "Тенант не найден",
  denied: "Нужно войти как администратор платформы",
  tenantDenied: "Недостаточно прав",
  tenantTab: "Пакеты",
  tenantHelp:
    "Назначьте релиз Publisher (slug@version): пакет импортируется и участвует в поиске и чате. Содержимое организация не редактирует.",
  tenantAdminNav: "Пакеты знаний",
  tenantAdminTitle: "Подключённые знания",
  tenantAdminDescription:
    "Готовые базы знаний платформы. Подключение включает пакет в поиск и чат без копирования файлов. Отключение сразу убирает его из ответов.",
  tenantEmptyTitle: "Нет пакетов для подключения",
  tenantEmptyDescription:
    "Когда платформа опубликует пакет, он появится здесь. Черновики организациям не видны.",
  tenantColumnPackage: "Пакет",
  tenantColumnDomain: "Область",
  tenantColumnEnabled: "Доступ",
  tenantColumnRelease: "Релиз",
  tenantColumnAssigned: "Назначен",
  tenantNoRelease: "Ещё нет релиза",
  tenantNoDiskRelease: "Нет релизов на диске",
  tenantAssignRelease: "Назначить релиз",
  tenantAssignPending: "Назначаем…",
  tenantAssignVersionLabel: "Версия релиза",
  tenantAssignVersionHelp:
    "Каталог data/packs/{slug}/{version} или zip в _exports. Импорт без полного индекса.",
  tenantAssignVersionRequired: "Выберите версию релиза",
  assignNeedVersion: "Укажите версию релиза Publisher (без draft)",
  tenantAssignedNone: "Не назначен",
  tenantEnable: "Подключить",
  tenantDisable: "Отключить",
  tenantEnabled: "Подключён",
  tenantDisabled: "Выключен",
  tenantDisconnectTitle: "Отключить пакет?",
  tenantDisconnectBody:
    "Пакет сразу исчезнет из поиска и чата сотрудников. Документы организации не затронуты. Назначенная версия сохранится.",
  tenantDisconnectConfirm: "Отключить",
  tenantDisconnectCancel: "Отмена",
  tenantCannotEnableArchived: "Архивный пакет нельзя включить",
  tenantCannotEnableDraft: "Сначала опубликуйте пакет",
  sourceSection: "Источники",
  sourceHelp:
    "Откуда знания: закон, акт, разъяснение. Каждый документ привязан к одному источнику.",
  sourceCreate: "Добавить источник",
  sourceCreateTitle: "Новый источник",
  sourceNameLabel: "Название",
  sourceSlugLabel: "Идентификатор",
  sourceSlugHelp:
    "Латиница, цифры, точка и дефис. Например tax.fns.calendar. Если пусто — задаётся автоматически.",
  sourceKindLabel: "Тип",
  sourceDescriptionLabel: "Описание",
  sourceReuseLabel: "Право использования",
  sourceReuseHelp:
    "Пока не проверено — документы с сайта не забираем. «Можно копировать» или «по лицензии» — после проверки.",
  sourceReusePublic: "Можно копировать",
  sourceReuseLicensed: "По лицензии",
  sourceReuseLinkOnly: "Только ссылка",
  sourceReuseUnknown: "Не проверено",
  sourceReuseBlocked: "Запрещено",
  sourceIndexLabel: "Индексация",
  sourceIndexHelp:
    "Сразу — эмбеддинги и Wiki после загрузки. Вручную — только текст в консоли; поиск и Wiki после «Обновить индекс». Один режим на любой пакет.",
  sourceIndexAuto: "Сразу",
  sourceIndexManual: "Вручную",
  sourceInvalidIndexPolicy: "Выберите режим индексации",
  sourceEnabledLabel: "Источник включён",
  sourceBaseUrlLabel: "Базовый URL",
  sourceDiscoveryUrlLabel: "URL обнаружения",
  sourceParserLabel: "Парсер",
  sourceParserHelp: "Имя адаптера, например fns-calendar.",
  sourceScheduleLabel: "Расписание",
  sourceScheduleHelp: "Cron, например 0 */6 * * *. Пока не запускается само.",
  sourceLicenseLabel: "Лицензия / основание",
  sourceColumnReuse: "Сбор",
  sourceColumnIndex: "Индексация",
  sourceColumnRun: "Проверка",
  sourceColumnActions: "Действия",
  sourceDisabledTag: "Выключен",
  sourceCheck: "Проверить обновления",
  sourceFetch: "Загрузить",
  sourceUpload: "Добавить документ",
  sourceRefreshTexts: "Обновить тексты",
  sourceRefreshTextsEmpty: "В источнике нет документов",
  sourceRefreshTextsNone: "Обновление текста уже выполняется",
  sourceRefreshTextsQueued: "Тексты в очереди. Индекс и Wiki не трогаем.",
  sourceCheckPending: "Ставим в очередь…",
  sourceFetchPending: "Ставим загрузку…",
  sourceIngestNoParser: "Укажите парсер источника, например fns-calendar",
  sourceIngestUnknownParser: "Этот парсер ещё не подключён",
  sourceRunNone: "Ещё не проверяли",
  sourceRunPending: "В очереди",
  sourceRunProcessing: "Идёт проверка",
  sourceRunSuccess: "Обновлён",
  sourceRunSkipped: "Без изменений",
  sourceRunFailed: "Ошибка",
  sourceRunBlocked: "Нет права",
  sourceInvalidSlug: "Идентификатор источника: латиница, цифры, точка и дефис",
  sourceInvalidUrl: "URL источника должен начинаться с https://",
  sourceInvalidReusePolicy: "Выберите право использования",
  sourceInvalidParser: "Слишком длинное имя парсера",
  sourceInvalidSchedule: "Слишком длинное расписание",
  sourceKindLaw: "Закон / кодекс",
  sourceKindRegulation: "Подзаконный акт",
  sourceKindGuidance: "Разъяснение",
  sourceKindOther: "Другое",
  sourceKindTipLaw: "Федеральный закон или кодекс — основной слой норм.",
  sourceKindTipRegulation: "Постановление, приказ или иной подзаконный акт.",
  sourceKindTipGuidance: "Письма и разъяснения ведомств (ФНС, Минфин и т.п.).",
  sourceKindTipOther: "Прочий тип источника, не попавший в основные категории.",
  sourceReuseTipPublic: "Можно копировать текст с сайта в пакет после проверки.",
  sourceReuseTipLicensed: "Копирование по лицензии или иному основанию.",
  sourceReuseTipLinkOnly: "В пакет только ссылка, текст с сайта не забираем.",
  sourceReuseTipUnknown: "Право ещё не проверено — документы с сайта не забираем.",
  sourceReuseTipBlocked: "Забирать контент нельзя.",
  sourceDisabledTip:
    "Источник выключен: проверки обновлений и загрузки не выполняются.",
  sourceUpdateOnTip:
    "Автообновление включено. Нажмите, чтобы выключить.",
  sourceUpdateOffTip:
    "Автообновление выключено. Нажмите, чтобы включить.",
  sourceIndexTipAuto:
    "Сразу — эмбеддинги и Wiki после загрузки документа.",
  sourceIndexTipManual:
    "Вручную — в консоли только текст; поиск и Wiki после «Обновить индекс».",
  sourceRunTipNone: "По этому источнику ещё не было проверки обновлений.",
  sourceRunTipPending: "Проверка или загрузка стоит в очереди.",
  sourceRunTipProcessing: "Сейчас идёт проверка или загрузка.",
  sourceRunTipSuccess: "Последний прогон завершился успешно, были изменения.",
  sourceRunTipSkipped: "Проверили — новых или изменённых документов нет.",
  sourceRunTipFailed: "Последний прогон завершился с ошибкой.",
  sourceRunTipBlocked: "Прогон не выполнен: нет права на использование контента.",
  sourceRunChangedTip: "Сколько документов изменилось в последнем успешном прогоне.",
  sourceInvalidName: "Укажите название источника",
  sourceInvalidKind: "Выберите тип источника",
  sourceNameTaken: "Источник с таким названием уже есть в пакете",
  sourceMissing: "Источник не найден",
  sourceEmptyTitle: "Пока нет документов",
  sourceEmptyDescription:
    "Импортируйте Knowledge Pack из Publisher — появятся источники и документы. Редакция корпуса в Platform недоступна.",
  sourceColumnName: "Источник",
  sourceColumnKind: "Тип",
  sourceColumnDocs: "Документы",
  documentsSection: "Документы",
  documentsHelp:
    "Файлы в общем хранилище пакета. Индексируются один раз для всех подключённых организаций.",
  documentsUpload: "Загрузить документ",
  documentsUploadTitle: "Документ в пакет",
  packImport: "Импорт pack",
  packImportTitle: "Импорт Knowledge Pack",
  packImportHelp:
    "Каталог относительно data/packs (или KNOWLEDGE_PACK_ROOT), например demo-sample/0.1.0. Документы создаются с разбором текста; полный индекс — вручную.",
  packImportPathLabel: "Путь к pack",
  packImportPathHelp: "Относительный путь к каталогу с manifest.json",
  packImportPending: "Импортируем…",
  packImportOk: "Импорт завершён",
  packImportSummary: (created: number, updated: number, skipped: number) =>
    `Создано ${created}, обновлено ${updated}, без изменений ${skipped}`,
  documentsEmptyTitle: "Пока нет документов",
  documentsEmptyDescription:
    "Загрузите PDF, DOCX, TXT или MD в выбранный источник.",
  documentsEmptyInSource: "В этом источнике пока нет документов.",
  documentsColumnTitle: "Название",
  documentsColumnSource: "Источник",
  documentsColumnOrigin: "Как попал",
  documentsColumnUpdated: "Загружен",
  documentsColumnChecked: "Проверен",
  documentsColumnStatus: "Статус",
  documentsColumnIndex: "Индекс",
  documentsIndexed: "В индексе",
  documentsNotIndexed: "Ещё нет",
  documentsWikiIndex: "Индексировать Wiki",
  documentsWikiQueued:
    "Wiki обновляется. Факты появятся во вкладке Wiki как PROPOSED.",
  documentsWikiNoText: "Сначала нужен разобранный текст документа",
  documentsOriginAll: "Все",
  documentsOriginSource: "С источника",
  documentsOriginUpload: "Загружены",
  documentsOriginAria: "Как документ попал в пакет",
  documentsFixtureAll: "Любые",
  documentsFixtureProd: "Прод",
  documentsFixtureOnly: "Фикстуры",
  documentsFixtureAria: "Фикстуры в названии документа",
  documentsOpen: "Открыть",
  documentsRefreshText: "Обновить текст",
  documentsRefreshQueued: "Текст обновляется. Индекс и Wiki не трогаем.",
  documentsForceFetch: "Загрузить оригинал",
  documentsForceFetchQueued: "Оригинал запрошен принудительно.",
  documentsForceFetchNoUrl: "У документа нет URL источника",
  documentsReindex: "Обновить индекс",
  documentsDelete: "Удалить",
  documentsDeleteTitle: "Удалить документ из пакета?",
  documentsDeleteBody:
    "Файл, индекс и связанные факты пакета будут удалены. У подключённых организаций документ сразу пропадёт из поиска и чата.",
  documentsDeleteConfirm: "Удалить",
  documentsDeleteCancel: "Отмена",
  documentsMissing: "Документ не найден в этом пакете",
  documentShare: "Подключить к пакету",
  documentShareHelp:
    "Документ остаётся здесь. Другой пакет получит его в поиске без копии и без повторного индекса.",
  documentShareOk: "Подключено",
  documentShareHome: "Документ уже в этом пакете",
  documentShareExists: "Пакет уже подключён к этому документу",
  documentShareTarget: "Пакет",
  documentUnshare: "Отключить",
  documentSharesEmpty: "Пока не подключён к другим пакетам.",
  documentsEditTitle: "Название",
  documentsEditTitleHelp: "Так документ виден в поиске и чате. Имя файла не меняется.",
  documentsEditSource: "Источник",
  documentsEditSourceHelp: "К какому источнику относится документ.",
  documentsSave: "Сохранить",
  documentsDownload: "Скачать файл",
  documentsOpenOrigin: "Исходный документ",
  documentsOpenOriginHelp:
    "Официальная страница. Можно скопировать или поправить. Файл в хранилище не меняется.",
  documentsInvalidOriginUrl: "Укажите ссылку http:// или https://",
  documentsTextTitle: "Текст",
  documentsTextEmpty: "Текст ещё не извлечён или файл без текста.",
  documentTabsAria: "Документ пакета",
  documentsMetaFile: "Файл",
  documentsMetaStatus: "Статус",
  documentsMetaIndex: "Индекс",
  sourceEdit: "Изменить",
  sourceEditTitle: "Источник",
  sourceDelete: "Удалить",
  sourceDeleteTitle: "Удалить источник?",
  sourceDeleteBody: "Источник без документов можно удалить.",
  sourceDeleteHasDocs: "Сначала удалите или перенесите документы источника",
  sourceDeleteConfirm: "Удалить",
  sourceDeleteCancel: "Отмена",
  uploadEmpty: "Выберите файл",
  uploadTooLarge: "Файл больше 30 МБ",
  uploadAcceptLabel: "PDF, DOCX, TXT или MD",
  uploadMime: "Нужен PDF, DOCX, TXT или MD",
  uploadSourceRequired: "Выберите источник",
  uploadSaved: "Файл принят в очередь индексации",
} as const;

export type KnowledgeSourceKind = "LAW" | "REGULATION" | "GUIDANCE" | "OTHER";

export type SourceReusePolicyName =
  | "PUBLIC_REUSE"
  | "LICENSED"
  | "LINK_ONLY"
  | "UNKNOWN"
  | "BLOCKED";

export type SourceIndexPolicyName = "AUTO" | "MANUAL";

export function parseKnowledgeSourceKind(
  raw: string,
): KnowledgeSourceKind | null {
  if (
    raw === "LAW" ||
    raw === "REGULATION" ||
    raw === "GUIDANCE" ||
    raw === "OTHER"
  ) {
    return raw;
  }
  return null;
}

export function knowledgeSourceReuseLabel(policy: SourceReusePolicyName): string {
  if (policy === "PUBLIC_REUSE") {
    return knowledgePackageCopy.sourceReusePublic;
  }
  if (policy === "LICENSED") {
    return knowledgePackageCopy.sourceReuseLicensed;
  }
  if (policy === "LINK_ONLY") {
    return knowledgePackageCopy.sourceReuseLinkOnly;
  }
  if (policy === "BLOCKED") {
    return knowledgePackageCopy.sourceReuseBlocked;
  }
  return knowledgePackageCopy.sourceReuseUnknown;
}

export function knowledgeSourceIndexLabel(
  policy: SourceIndexPolicyName,
): string {
  if (policy === "MANUAL") {
    return knowledgePackageCopy.sourceIndexManual;
  }
  return knowledgePackageCopy.sourceIndexAuto;
}

export function knowledgeSourceIndexTagType(
  policy: SourceIndexPolicyName,
): "green" | "gray" {
  return policy === "AUTO" ? "green" : "gray";
}

export function documentsForPackageSource<T extends { sourceId: string | null }>(
  rows: T[],
  sourceId: string,
): T[] {
  return rows.filter((row) => row.sourceId === sourceId);
}

export function knowledgeSourceRunLabel(status: string | null | undefined): string {
  if (status === "PENDING") {
    return knowledgePackageCopy.sourceRunPending;
  }
  if (status === "PROCESSING") {
    return knowledgePackageCopy.sourceRunProcessing;
  }
  if (status === "SUCCESS") {
    return knowledgePackageCopy.sourceRunSuccess;
  }
  if (status === "SKIPPED") {
    return knowledgePackageCopy.sourceRunSkipped;
  }
  if (status === "FAILED") {
    return knowledgePackageCopy.sourceRunFailed;
  }
  if (status === "BLOCKED") {
    return knowledgePackageCopy.sourceRunBlocked;
  }
  return knowledgePackageCopy.sourceRunNone;
}

export function knowledgeSourceRunTagType(
  status: string | null | undefined,
): "green" | "red" | "gray" | "blue" {
  if (status === "SUCCESS") {
    return "green";
  }
  if (status === "FAILED" || status === "BLOCKED") {
    return "red";
  }
  if (status === "PENDING" || status === "PROCESSING") {
    return "blue";
  }
  return "gray";
}

export function knowledgePackageActivityKindLabel(
  kind: string | null | undefined,
): string {
  if (kind === "CHECK") {
    return knowledgePackageCopy.journalKindCheck;
  }
  if (kind === "FETCH") {
    return knowledgePackageCopy.journalKindFetch;
  }
  if (kind === "PARSE_TEXT") {
    return knowledgePackageCopy.journalKindParseText;
  }
  if (kind === "INDEX") {
    return knowledgePackageCopy.journalKindIndex;
  }
  return kind?.trim() || "—";
}

export function knowledgePackageActivityTarget(params: {
  sourceName: string | null;
  documentTitle: string | null;
}): string {
  if (params.documentTitle?.trim()) {
    return params.documentTitle.trim();
  }
  if (params.sourceName?.trim()) {
    return params.sourceName.trim();
  }
  return "—";
}

export function sourceRunChangedLabel(changed: number): string | null {
  if (changed <= 0) {
    return null;
  }
  if (changed === 1) {
    return "1 новый";
  }
  return `${changed} новых`;
}

export type PackageDocumentOrigin = "source" | "upload";

export type PackageDocumentOriginSlice = "all" | PackageDocumentOrigin;

export function packageDocumentOrigin(
  ingestSource: string | null | undefined,
): PackageDocumentOrigin {
  return ingestSource === "SOURCE" ? "source" : "upload";
}

export function packageDocumentOriginLabel(
  origin: PackageDocumentOrigin,
): string {
  if (origin === "source") {
    return knowledgePackageCopy.documentsOriginSource;
  }
  return knowledgePackageCopy.documentsOriginUpload;
}

/** «Загружен» / «Проверен»: formatted datetime or em dash. */
export function packageDocumentAtLabel(
  value: Date | null | undefined,
  format: (value: Date) => string,
): string {
  return value ? format(value) : "—";
}

export function filterPackageDocumentsByOrigin<
  T extends { origin: PackageDocumentOrigin },
>(rows: readonly T[], slice: PackageDocumentOriginSlice): T[] {
  if (slice === "all") {
    return [...rows];
  }
  return rows.filter((row) => row.origin === slice);
}

export function packageDocumentSourceHref(
  officialUrl?: string | null,
  sourceUrl?: string | null,
): string | null {
  const raw = (officialUrl ?? sourceUrl ?? "").trim();
  if (raw.startsWith("https://") || raw.startsWith("http://")) {
    return raw;
  }
  return null;
}

export function parsePackageDocumentOriginUrl(
  raw: string,
): { ok: true; value: string | null } | { ok: false; error: string } {
  const value = raw.trim();
  if (!value) {
    return { ok: true, value: null };
  }
  if (value.length > 2000) {
    return { ok: false, error: knowledgePackageCopy.documentsInvalidOriginUrl };
  }
  try {
    const url = new URL(value);
    if (url.protocol !== "https:" && url.protocol !== "http:") {
      return { ok: false, error: knowledgePackageCopy.documentsInvalidOriginUrl };
    }
  } catch {
    return { ok: false, error: knowledgePackageCopy.documentsInvalidOriginUrl };
  }
  return { ok: true, value };
}

export function knowledgeSourceKindLabel(kind: KnowledgeSourceKind): string {
  if (kind === "LAW") {
    return knowledgePackageCopy.sourceKindLaw;
  }
  if (kind === "REGULATION") {
    return knowledgePackageCopy.sourceKindRegulation;
  }
  if (kind === "GUIDANCE") {
    return knowledgePackageCopy.sourceKindGuidance;
  }
  return knowledgePackageCopy.sourceKindOther;
}

export function knowledgeSourceKindTip(kind: KnowledgeSourceKind): string {
  if (kind === "LAW") {
    return knowledgePackageCopy.sourceKindTipLaw;
  }
  if (kind === "REGULATION") {
    return knowledgePackageCopy.sourceKindTipRegulation;
  }
  if (kind === "GUIDANCE") {
    return knowledgePackageCopy.sourceKindTipGuidance;
  }
  return knowledgePackageCopy.sourceKindTipOther;
}

export function knowledgeSourceReuseTip(
  policy: SourceReusePolicyName,
  enabled: boolean,
): string {
  if (!enabled) {
    return knowledgePackageCopy.sourceDisabledTip;
  }
  if (policy === "PUBLIC_REUSE") {
    return knowledgePackageCopy.sourceReuseTipPublic;
  }
  if (policy === "LICENSED") {
    return knowledgePackageCopy.sourceReuseTipLicensed;
  }
  if (policy === "LINK_ONLY") {
    return knowledgePackageCopy.sourceReuseTipLinkOnly;
  }
  if (policy === "BLOCKED") {
    return knowledgePackageCopy.sourceReuseTipBlocked;
  }
  return knowledgePackageCopy.sourceReuseTipUnknown;
}

export function knowledgeSourceIndexTip(
  policy: SourceIndexPolicyName,
): string {
  if (policy === "MANUAL") {
    return knowledgePackageCopy.sourceIndexTipManual;
  }
  return knowledgePackageCopy.sourceIndexTipAuto;
}

export function knowledgeSourceUpdateTip(enabled: boolean): string {
  return enabled
    ? knowledgePackageCopy.sourceUpdateOnTip
    : knowledgePackageCopy.sourceUpdateOffTip;
}

export function knowledgeSourceRunTip(
  status: string | null | undefined,
): string {
  if (status === "PENDING") {
    return knowledgePackageCopy.sourceRunTipPending;
  }
  if (status === "PROCESSING") {
    return knowledgePackageCopy.sourceRunTipProcessing;
  }
  if (status === "SUCCESS") {
    return knowledgePackageCopy.sourceRunTipSuccess;
  }
  if (status === "SKIPPED") {
    return knowledgePackageCopy.sourceRunTipSkipped;
  }
  if (status === "FAILED") {
    return knowledgePackageCopy.sourceRunTipFailed;
  }
  if (status === "BLOCKED") {
    return knowledgePackageCopy.sourceRunTipBlocked;
  }
  return knowledgePackageCopy.sourceRunTipNone;
}

export function knowledgePackageStatusLabel(
  status: KnowledgePackageStatus,
): string {
  if (status === "PUBLISHED") {
    return knowledgePackageCopy.statusPublished;
  }
  if (status === "ARCHIVED") {
    return knowledgePackageCopy.statusArchived;
  }
  return knowledgePackageCopy.statusDraft;
}

export function knowledgePackageStatusTagType(
  status: KnowledgePackageStatus,
): "green" | "gray" | "blue" {
  if (status === "PUBLISHED") {
    return "green";
  }
  if (status === "ARCHIVED") {
    return "gray";
  }
  return "blue";
}

export function parseKnowledgePackageStatus(
  raw: string,
): KnowledgePackageStatus | null {
  if (raw === "DRAFT" || raw === "PUBLISHED" || raw === "ARCHIVED") {
    return raw;
  }
  return null;
}

export function parseCreateKnowledgePackageInput(input: {
  name: string;
  slug: string;
  domainName: string;
  domainSlug: string;
  description?: string;
}):
  | {
      ok: true;
      value: {
        name: string;
        slug: string;
        domainName: string;
        domainSlug: string;
        description: string | null;
      };
    }
  | { ok: false; error: string } {
  const name = input.name.trim();
  const slug = parseTenantSlug(input.slug);
  const domainName = input.domainName.trim();
  const domainSlug = parseTenantSlug(input.domainSlug);
  const description = (input.description ?? "").trim() || null;

  if (!name) {
    return { ok: false, error: knowledgePackageCopy.invalidName };
  }
  if (!slug) {
    return { ok: false, error: knowledgePackageCopy.invalidSlug };
  }
  if (!domainName) {
    return { ok: false, error: knowledgePackageCopy.invalidDomainName };
  }
  if (!domainSlug) {
    return { ok: false, error: knowledgePackageCopy.invalidDomainSlug };
  }

  return {
    ok: true,
    value: { name, slug, domainName, domainSlug, description },
  };
}

export function parseUpdateKnowledgePackageInput(input: {
  name: string;
  description?: string;
  status: string;
}):
  | {
      ok: true;
      value: {
        name: string;
        description: string | null;
        status: KnowledgePackageStatus;
      };
    }
  | { ok: false; error: string } {
  const name = input.name.trim();
  const description = (input.description ?? "").trim() || null;
  const status = parseKnowledgePackageStatus(input.status);
  if (!name) {
    return { ok: false, error: knowledgePackageCopy.invalidName };
  }
  if (!status) {
    return { ok: false, error: knowledgePackageCopy.invalidStatus };
  }
  return { ok: true, value: { name, description, status } };
}

export function filterKnowledgePackages<
  T extends { name: string; slug: string; domainName: string },
>(rows: T[], query: string): T[] {
  const needle = query.trim().toLowerCase();
  if (!needle) {
    return rows;
  }
  return rows.filter(
    (row) =>
      row.name.toLowerCase().includes(needle) ||
      row.slug.toLowerCase().includes(needle) ||
      row.domainName.toLowerCase().includes(needle),
  );
}

/** Package ids a tenant may use in retrieval (enabled entitlement). */
export function enabledPackageIds(
  entitlements: readonly { packageId: string; enabled: boolean }[],
): string[] {
  return entitlements
    .filter((row) => row.enabled)
    .map((row) => row.packageId);
}

export function canEnablePackageForTenant(
  status: KnowledgePackageStatus,
): { ok: true } | { ok: false; error: string } {
  if (status === "ARCHIVED") {
    return { ok: false, error: knowledgePackageCopy.tenantCannotEnableArchived };
  }
  if (status === "DRAFT") {
    return { ok: false, error: knowledgePackageCopy.tenantCannotEnableDraft };
  }
  return { ok: true };
}

const RELEASE_VERSION_RE = /^[a-z0-9]+([._-][a-z0-9]+)*$/i;

export function parseCreatePackageReleaseInput(input: {
  version: string;
  notes: string;
}):
  | { ok: true; value: { version: string; notes: string } }
  | { ok: false; error: string } {
  const version = input.version.trim();
  const notes = input.notes.trim();
  if (!version || !RELEASE_VERSION_RE.test(version)) {
    return { ok: false, error: knowledgePackageCopy.releaseInvalidVersion };
  }
  if (!notes) {
    return { ok: false, error: knowledgePackageCopy.releaseInvalidNotes };
  }
  return { ok: true, value: { version, notes } };
}

export function adminPackagesHref(): string {
  return "/admin/packages";
}

export function formatPackageReleaseSummary(params: {
  version: string | null;
  publishedAtLabel: string | null;
  notesPreview: string | null;
}): string {
  if (!params.version || !params.publishedAtLabel) {
    return knowledgePackageCopy.tenantNoRelease;
  }
  const notes = params.notesPreview?.trim();
  if (!notes) {
    return `${params.version} · ${params.publishedAtLabel}`;
  }
  return `${params.version} · ${params.publishedAtLabel} — ${notes}`;
}

export function packageReleaseNotesPreview(
  notes: string,
  maxLength = 120,
): string {
  const trimmed = notes.trim().replace(/\s+/g, " ");
  if (trimmed.length <= maxLength) {
    return trimmed;
  }
  return `${trimmed.slice(0, maxLength - 1)}…`;
}
